import { useEffect } from "react";

/**
 * Sets `document.title` for the current route and restores the previous title
 * on unmount. Works seamlessly with React Router by re-running whenever the
 * `title` argument changes.
 *
 * Usage:
 *   useDocumentTitle("Pricing — QorTrace");
 *
 * Convention: keep titles short, human, and end with " — QorTrace" so they
 * read well in browser tabs, shared links, and analytics page-view rows.
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const previous = document.title;
    if (title && title !== previous) {
      document.title = title;
    }
    return () => {
      // Restore previous title only if we mutated it. This avoids stomping
      // on a title that another component has set in the meantime.
      if (document.title === title && previous) {
        document.title = previous;
      }
    };
  }, [title]);
}
